module.exports = "<div infinite-scroll=$ctrl.onVisible() infinite-scroll-distance=3 infinite-scroll-immediate-check=false> <spinner></spinner> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/infinite-trigger/infinite-trigger.template.html
// module id = 558
// module chunks = 0